/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
  password: Types.Scalars['String'];
  customerCode?: Types.InputMaybe<Types.Scalars['String']>;
  authStepToken?: Types.InputMaybe<Types.Scalars['String']>;
  mfaToken?: Types.InputMaybe<Types.Scalars['String']>;
  rememberMe?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type LoginMutation = { authenticate: { token: string, rememberMeToken?: string | undefined, mfa: { status: Types.MfaStatus, method: Types.MfaMethod }, user?: { backupEmail?: string | undefined, customerCode: string, id: number, type: Types.UserType } | undefined } };


export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!, $customerCode: String, $authStepToken: String, $mfaToken: String, $rememberMe: Boolean) {
  authenticate(email: $email, password: $password, customerCode: $customerCode, authStepToken: $authStepToken, mfaToken: $mfaToken, rememberMe: $rememberMe) {
    token
    mfa {
      status
      method
    }
    user {
      backupEmail
      customerCode
      id
      type
    }
    rememberMeToken
  }
}
    `;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      customerCode: // value for 'customerCode'
 *      authStepToken: // value for 'authStepToken'
 *      mfaToken: // value for 'mfaToken'
 *      rememberMe: // value for 'rememberMe'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;